module.exports = __webpack_public_path__ + "img/paul_74.49e5a430.jpg";